import React from "react"
import styled from "styled-components"
import Spinner from './atoms/Spinner'
import Text from "../styledComponents/TextStyled"

const WrapLoading = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 32px;
  gap: 16px;
  @media (max-height: 600px) {
    transition: all 0.5s ease;
    padding: 16px;
  }
`

const CustomLoading = () => {
  return (
    <WrapLoading>
      <Spinner />
      <Text textStyle='small'>Cargando...</Text>
    </WrapLoading>
  )
}

export default CustomLoading
